import React from 'react';
import { Layout, LayoutItem, Paragraph, ParagraphHeader } from '@axiom/ui';

export type EngagementDetailsFirstDayContactRowProps = {
  name: string;
  label: string;
  value: string | null | undefined;
};

export const EngagementDetailsFirstDayContactRow = ({
  name,
  label,
  value,
}: EngagementDetailsFirstDayContactRowProps) => {
  if (!value) return null;

  return (
    <Layout name={name}>
      <LayoutItem rightGutter="8px">
        <ParagraphHeader>{label}</ParagraphHeader>
      </LayoutItem>
      <LayoutItem>
        <Paragraph>{value}</Paragraph>
      </LayoutItem>
    </Layout>
  );
};
